import * as React from "react";
import moment from "moment";
import { useIntl } from "react-intl";
import "./DoctorSignatureSimple.css";

interface DoctorSignatureSimpleProps {
  evaluator?: string;
  reportDate?: string;
  introduction?: string;
}

const DoctorSignatureSimple: React.FC<DoctorSignatureSimpleProps> = ({
  evaluator,
  reportDate = moment().format("YYYY-MM-DD"),
  introduction
}) => {
  const intl = useIntl();
  
  return (
    <div className="doctorSignatureSimple">
      <div className="signatureMainRow">
        <div className="signatureFieldRow">
          <span className="fieldLabel">{intl.formatMessage({ id: "evaluator" })}：</span>
          <span className="fieldValue signature">{evaluator && <img width={80} height={30} src={evaluator} />}</span>
        </div>
        <div className="signatureFieldRow">
          <span className="fieldLabel">{intl.formatMessage({ id: "reportDate" })}：</span>
          <span className="fieldValue">{moment(reportDate, ["YYYY年MM月DD日", "YYYY-MM-DD"]).format("YYYY-MM-DD")}</span>
        </div>
      </div>
      
        <div className="doctorIntroRow">
          {introduction?.trim() && (
            <>
          <span className="fieldLabel">{intl.formatMessage({ id: "introduction" })}：</span>
          <span className="introText">{introduction}</span>
          </>
          )}&nbsp;
        </div>
      
    </div>
  );
};

export default DoctorSignatureSimple;